





















































































































































































































































import skillbar from '@/components/skillbar.vue';
import SelectSearch from '@/components/select-search.vue';
import { ref, defineComponent, onMounted, computed } from '@vue/composition-api';
import store from '@/store';
import Apierrormessage from '@/components/Apierrormessage.vue';
import validation from '@/data/validation.vue';
// import { bus } from '@/main';
// import router from '@/router';
import Vue from 'vue';

const bus = new Vue();

const defaultObjInit = () => ({
  skillId: '',
  name: '',
  description: '',
  skillMasterId: '',
  ratingDescription: 0,
  addToMyPlan: false,
  MyPlan_Relevant: false,
  subSkills: [
    {
      skillId: '',
      name: '',
      description: '',
      skillMasterId: '',
      ratingDescription: 0,
      addToMyPlan: false,
    },
  ],
});
export default defineComponent({
  name: 'Domain',
  components: {
    skillbar,
    SelectSearch,
    Apierrormessage,
    validation,
  },
  setup() {
    const selectedDomains = ref([{ ...defaultObjInit() }]);
    const isChangeRole = ref(false);
    const isButtonCheck = ref(false);
    const renderReady = ref(false);
    const apiError = ref(false);
    const loading = ref(false);
    const domainMandate = ref(false);
    const toggleAccordianVal = ref(1);
    const fetchInitialData = () => {
      store.dispatch('domain/getDomain');
      store.dispatch('profile/getEmployeeProfile');
      store.dispatch('profile/getSkillsProficiency');
      renderReady.value = true;
    };
    onMounted(() => {
      fetchInitialData();
    });
    const skillsDomains = computed(() => store.getters['domain/skillsDomains']);
    const skillsEmployeeProfile = computed(() => store.getters['profile/skillsEmployeeProfile']);
    const skillsLevels = computed(() => store.getters['profile/skillsLevels']);
    const proceedButtonState = computed(() => {
      const arr = JSON.parse(JSON.stringify(selectedDomains.value));
      /* eslint operator-linebreak: ["error", "after"] */
      if (arr.length === 1 && arr.find((x: any) => x.addToMyPlan) && arr[0].name.toLowerCase() === 'not available') return false;
      return (
        arr.find((x: any) => x.skillId === '') ||
        !(arr.find((x: any) => x.name.toLowerCase() === 'not available') || arr.find((x: any) => (x.addToMyPlan ? x.MyPlan_Relevant : false))) ||
        !!arr.find(
          (x: any) =>
            // eslint-disable-next-line implicit-arrow-linebreak
            !(x.addToMyPlan ? x.name.toLowerCase() === 'not available' : x.name.toLowerCase() === 'not available' || x.name.toLowerCase() === 'not applicable' || x.name.toLowerCase() === 'na') &&
            (!x.skillId || !x.ratingDescription || (x.subSkills.length && !x.subSkills.find((y: any) => y.ratingDescription))),
        )
      );
      // return (
      //   arr.find((x: any) => x.skillId === '') ||
      //   !!arr.find(
      //     (x: any) =>
      //       // eslint-disable-next-line implicit-arrow-linebreak
      //       !(x.addToMyPlan ? x.name.toLowerCase() === 'not available' : x.name.toLowerCase() === 'not available' || x.name.toLowerCase() === 'not applicable' || x.name.toLowerCase() === 'na') &&
      //       (!x.skillId || !x.ratingDescription || (x.subSkills.length && !x.subSkills.find((y: any) => y.ratingDescription))),
      //   )
      // );
    });
    const proceedToNextPage = () => {
      bus.$emit('proceedToNextPage');
    };
    const proceedToNextTab = (path: any) => {
      if (!skillsEmployeeProfile.value.profileComplete && !skillsEmployeeProfile.value.isLegacy && !isChangeRole.value) {
        isButtonCheck.value = true;
        console.log('proceedToNextTab', path);
        bus.$emit('proceedToNextPage', isChangeRole, isButtonCheck);
      } else if (isChangeRole.value) {
        console.log('isChangeRolePath', path);
        // @ts-ignore
        this.$router.push(path);
      }
    };
    const openSkillDefinition = (index: any) => {
      bus.$emit('openSkillDefinition', index);
    };
    const showExtraOptionsModal = (index: any) => {
      bus.$emit('showExtraOptionsModal', index);
    };
    const addRow = () => {
      selectedDomains.value.push(defaultObjInit());
    };
    const deleteRow = (i: any) => {
      const index = i;
      // const row = r;
      // if (typeof index === 'object' && !row) {
      //   index = extraInfoOptions.value.index;
      //   row = extraInfoOptions.value.type;
      // }
      selectedDomains.value = [...selectedDomains.value.slice(0, index), ...selectedDomains.value.slice(index + 1, selectedDomains.value.length)];
    };
    const toggleAccordian = () => {
      toggleAccordianVal.value = 0;
    };
    const toggleAccordianaddvalue = (i: any) => {
      toggleAccordianVal.value = i + 1;
    };
    const radioBtnClicked = (event: any) => {
      const { target } = event;
      const { id, dataset } = target;
      const { index, subIndex } = dataset;
      // if ((isIE || isEdge) && !isMobileOnly) return;
      // if (selectedDomains && selectedDomains.value[index].subSkills[subIndex]) {
      //   const newVAlue = selectedDomains.value[index].subSkills[subIndex].ratingDescription;
      //   console.log('id', newVAlue);
      // }
      // const newVAlue = selectedDomains.value[index]?.subSkills[subIndex];
      if (id && id.includes('sub-domain-service-radio-') && selectedDomains.value[index].subSkills[subIndex].ratingDescription) {
        selectedDomains.value[index].subSkills[subIndex].ratingDescription = 0;
      } else if (id && id.includes('domain-service-radio-') && selectedDomains.value[index].ratingDescription && !subIndex) {
        // selectedDomains.value[index].Level = 0;
      }
    };
    const inputValueChanged = (val: any, elem: any) => {
      // console.log('val====================', val);
      // console.log('elem-----------------------', elem);
      // const { key } = elem.dataset;
      // console.log('key', elem);
      // const { id } = elem || {};
      const id = elem || {};
      if (id && id.includes('domain-service-select-')) {
        const index = parseInt(id.split('domain-service-select-')[1], 10);
        const obj = skillsDomains.value?.find((x: any) => x.skillId === val.value);
        selectedDomains.value[index].skillId = obj.skillId;
        selectedDomains.value[index].name = obj.name;
        selectedDomains.value[index].ratingDescription = obj.ratingDescription || 0;
        selectedDomains.value[index].addToMyPlan = obj.addToMyPlan;
        selectedDomains.value[index].MyPlan_Relevant = false;
        selectedDomains.value[index].description = obj.description || '';
        selectedDomains.value[index].skillMasterId = obj.skillMasterId;
        selectedDomains.value[index].subSkills = JSON.parse(JSON.stringify(obj.subSkills || []));
      }
    };
    return {
      selectedDomains,
      isChangeRole,
      renderReady,
      apiError,
      loading,
      toggleAccordianVal,
      skillsDomains,
      skillsEmployeeProfile,
      skillsLevels,
      inputValueChanged,
      radioBtnClicked,
      toggleAccordianaddvalue,
      toggleAccordian,
      addRow,
      deleteRow,
      bus,
      proceedToNextPage,
      openSkillDefinition,
      showExtraOptionsModal,
      proceedButtonState,
      domainMandate,
      proceedToNextTab,
      isButtonCheck,
    };
  },
});
